/**
 * A middleware function that does nothing.
 */
export const noOpMiddleware = state => next => action => next(action);
